import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import MainLayout from "../components/MainLayout";
import Home from '../pages/Home';
import Dashboard from '../pages/admin/Dashboard';
import Facebooklogin from '../pages/admin/Facebooklogin';
import User from '../pages/admin/User';
import Newuser from '../pages/admin/Newuser';
import AdminLayout from '../components/AdminLayout';
import Newfacebookpost from '../pages/admin/Newfacebookpost';
import Facebookpost from '../pages/admin/Facebookpost';
import Newfacebookcampaign from '../pages/admin/Newfacebookcampaign';
import Newlinkedinpost from '../pages/admin/Newlinkedinpost';
import Newlinkedincampaign from '../pages/admin/Newlinkedincampaign';
import Linkedin from '../pages/admin/Linkedin';
import Facebookcampaign from '../pages/admin/Facebookcampaign';
import Linkedincampaign from '../pages/admin/Linkedincampaign';
import Instagram from '../pages/admin/Instagram';
import Newinstagrampost from '../pages/admin/Newinstagrampost';
import Newinstagramcampaign from '../pages/admin/Newinstagramcampaign';
import AnalyticsPage from '../pages/admin/AnalyticsPage';
import CampaignsPage from '../pages/admin/CampaignsPage';
import PostsPage from '../pages/admin/PostsPage';
import GalleryImages from '../pages/admin/GalleryImages';
import PostDetails from '../pages/admin/PostDetails';
import PlatformAccountTable from '../pages/admin/PlatformAccountTable';
import Settings from '../pages/admin/Settings';
import TwitterCallback from '../pages/admin/TwitterCallback';
import Createpost from '../pages/admin/Createpost';
import AllPosts from '../pages/admin/AllPosts'
import CreateCampaign  from '../pages/admin/CreateCampaign';
import Reports from '../pages/admin/Reports';
import   Campaigntest from '../pages/admin/Campaigntest';
import PostDetailsSampleData from '../pages/admin/PostDetailsSampleData';
import Dashboardtest from '../pages/admin/Dashboardtest';
const Allroutes = () => {
    return (
        <Router basename={'/'} >
            <Routes>
                <Route exact path="/" element={<MainLayout><Home /></MainLayout>} />
                <Route exact path="/login" element={<MainLayout><Home /></MainLayout>} />
                <Route exact path="/admin/campaigns" element={<AdminLayout  title={'Campaigns'}><CampaignsPage /></AdminLayout>} />
                <Route exact path="/admin/dashboardtest" element={<AdminLayout  title={'Campaigns'}>< Dashboardtest  /></AdminLayout>} />
              
            <Route exact path="/admin/posts" element={<AdminLayout  title={' Your Social Media Posts'}><PostsPage /></AdminLayout>} />
               <Route exact path="/admin/facebook-post" element={<AdminLayout  title={' Facebook '}>< Facebookpost /></AdminLayout>} />
                
               <Route exact path="/admin/allpost" element={<AdminLayout  title={'All Posts'}><AllPosts /></AdminLayout>} />
                <Route exact path="/admin/createpost" element={<AdminLayout  title={'Create Post'}><Createpost /></AdminLayout>} />

                {/* <Route exact path="/admin/all-posts" element={<AdminLayout  title={' Your Social Media Posts'}><PostDetails /></AdminLayout>} /> */}
                <Route exact path="/admin/all-posts" element={<AdminLayout  title={' Your Social Media Posts'}><PostDetailsSampleData /></AdminLayout>} />
                <Route exact path="/admin/create-new-post" element={<AdminLayout  title={'New Post'}>< Facebookpost /></AdminLayout>} />
                 <Route exact path="/admin/platformlogin" element={<AdminLayout  title={'Your Account'}><  PlatformAccountTable /></AdminLayout>} />
               
          <Route exact path="/admin/campaigntest" element={<AdminLayout  title={'Your Account'}><    Campaigntest /></AdminLayout>} />
               
              
                {/* AllPosts */}
                <Route exact path="/admin/reports" element={<AdminLayout  title={'Reports'}><Reports /></AdminLayout>} />
                
                {/* <Route exact path="/admin/platformaccounttable" element={<AdminLayout  title={' Your Account'}><PlatformAccountTable /></AdminLayout>} /> */}

                <Route exact path="/admin/settings" element={<AdminLayout  title={'Settings'}><Settings /></AdminLayout>} />
             
                <Route exact path="/admin/analytics" element={<AdminLayout  title={'Detailed Analytics'}><AnalyticsPage /></AdminLayout>} />
                <Route exact path="/admin/dashboard" element={<AdminLayout  title={'Dashboard'}><Dashboard  /></AdminLayout>} />
                <Route exact path="/admin/facebook" element={<AdminLayout  title={'Facebook'}><Facebooklogin /></AdminLayout>} />
                <Route exact path="/admin/linkedin" element={<AdminLayout  title={'Linkedin'}><Linkedin  /></AdminLayout>} />
                <Route exact path="/admin/instagram" element={<AdminLayout  title={'Instagram'}><Instagram  /></AdminLayout>} />
                <Route exact path="/admin/user" element={<AdminLayout  title={'Users Management'}><User  /></AdminLayout>} />
                <Route exact path="/admin/add-new-user" element={<AdminLayout  title={' New User'}>< Newuser /></AdminLayout>} />


   <Route exact path="/admin/createcampaign" element={<AdminLayout  title={'Create Campaign '}>< CreateCampaign /></AdminLayout>} />

             <Route exact path="/admin/newfacebookpost" element={<AdminLayout  title={'  Newfacebookpost'}><  Newfacebookpost /></AdminLayout>} />
            
         <Route exact path="/admin/add-new-facebook-post" element={<AdminLayout  title={' New Facebook Post'}>< Newfacebookpost /></AdminLayout>} /> 
           
                <Route exact path="/admin/facebook-campaign" element={<AdminLayout  title={' Campaigns '}>< Facebookcampaign /></AdminLayout>} />
            
                <Route exact path="/admin/add-new-facebook-campaign" element={<AdminLayout  title={'  New Facebook Campaign'}><  Newfacebookcampaign /></AdminLayout>} />
            
                <Route exact path="/admin/add-new-linkedin-post" element={<AdminLayout  title={'  New Linkedin Post'}>< Newlinkedinpost   /></AdminLayout>} />
                <Route exact path="/admin/add-new-linkedin-campaign" element={<AdminLayout  title={'  New Linkedin Campaign'}>< Newlinkedincampaign/></AdminLayout>} />
            
                <Route exact path="/admin/linkedin-campaign" element={<AdminLayout  title={'Linkedin'}>< Linkedincampaign/></AdminLayout>} />
           
           
           
           
                <Route exact path="/admin/add-new-instagram-post" element={<AdminLayout  title={'  New Instagram Post'}>< Newinstagrampost   /></AdminLayout>} />
               
           
                <Route exact path="/admin/add-new-instagram-campaign" element={<AdminLayout  title={'  New instagram Campaign'}>< Newinstagramcampaign/></AdminLayout>} />

                <Route exact path="/admin/media-gallery" element={<AdminLayout  title={'Media Gallery'}>< GalleryImages/></AdminLayout>} />

                <Route exact path="/admin/twitter-callback" element={<AdminLayout  title={'Twitter'}>< TwitterCallback/></AdminLayout>} />
            
           
           
                
           
           
            </Routes>
        </Router>
    )
}

export default Allroutes;